// Подключение сайта к новому бэкенду: счётчик посещений и автообновление страницы после правок в админке.
// Работает только когда адрес API задан при сборке (VUE_APP_API_URL): у старого API этих адресов нет.
// Без внешних библиотек: вебсокет говорит по протоколу Pusher, его поддерживает Laravel Reverb.

const ENABLED = !!process.env.VUE_APP_API_URL
const API = (process.env.VUE_APP_API_URL || '').replace(/\/+$/, '')

// внутренний slug сайта в бэкенде (picunda = Пицунда)
const slugOf = (site) => (site === 'picunda' ? 'pitsunda' : site)

let firstView = true

/** Одна запись на просмотр страницы. Без cookie и без личных данных: посетителя бэкенд различает ежедневно меняющимся хешем. */
export function trackView (site, route) {
  if (!ENABLED || !site || typeof fetch !== 'function') return
  if (/^(localhost|127\.|\[::1\])/.test(location.hostname)) return

  const q = route.query || {}
  const body = {
    path: route.path,
    referrer: firstView ? (document.referrer || null) : null,
    utm_source: q.utm_source || null,
    utm_medium: q.utm_medium || null,
    utm_campaign: q.utm_campaign || null
  }
  firstView = false

  try {
    fetch(API + '/api/v1/' + slugOf(site) + '/track', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
      keepalive: true
    }).catch(() => {})
  } catch (e) { /* аналитика не должна ломать сайт */ }
}

let socket = null
let retry = 0
let currentSite = null

/**
 * Слушает канал site.{slug}. Когда в админке меняются номера, цены или контент, вызывает onUpdate(scope).
 * Подключается лениво, после загрузки страницы; при обрыве переподключается с нарастающей паузой.
 */
export function listenForUpdates (site, onUpdate) {
  if (!ENABLED || !site || typeof WebSocket === 'undefined') return
  if (currentSite === site && socket) return
  currentSite = site
  if (socket) { try { socket.close() } catch (e) { /* уже закрыт */ } socket = null }

  // после полной загрузки страницы, чтобы вебсокет не мешал показу сайта
  const run = () => setTimeout(() => connect(site, onUpdate), 1500)
  document.readyState === 'complete' ? run() : window.addEventListener('load', run, { once: true })
}

async function connect (site, onUpdate) {
  let cfg
  try {
    const res = await fetch(API + '/api/v1/realtime')
    cfg = await res.json()
  } catch (e) { return }
  if (!cfg || !cfg.enabled || !cfg.key || !cfg.host) return

  const scheme = cfg.scheme === 'https' ? 'wss' : 'ws'
  const port = (scheme === 'wss' && cfg.port === 443) || (scheme === 'ws' && cfg.port === 80) ? '' : ':' + cfg.port
  const url = scheme + '://' + cfg.host + port + '/app/' + cfg.key + '?protocol=7&client=js&version=8.4.0&flash=false'

  let ws
  try { ws = new WebSocket(url) } catch (e) { return }
  socket = ws

  ws.onmessage = (event) => {
    let msg
    try { msg = JSON.parse(event.data) } catch (e) { return }

    if (msg.event === 'pusher:connection_established') {
      retry = 0
      ws.send(JSON.stringify({ event: 'pusher:subscribe', data: { channel: 'site.' + slugOf(site) } }))
    } else if (msg.event === 'pusher:ping') {
      ws.send(JSON.stringify({ event: 'pusher:pong', data: {} }))
    } else if (msg.event === 'content.updated') {
      let data = msg.data
      try { if (typeof data === 'string') data = JSON.parse(data) } catch (e) { data = {} }
      onUpdate((data && data.scope) || 'content')
    }
  }
  ws.onclose = () => {
    if (socket !== ws) return
    socket = null
    const wait = Math.min(60000, 2000 * Math.pow(2, retry++))
    setTimeout(() => { if (currentSite === site) connect(site, onUpdate) }, wait)
  }
  ws.onerror = () => { try { ws.close() } catch (e) { /* уже закрыт */ } }
}
